// extracted by mini-css-extract-plugin
export default {"flexRow":"FlexRowDiv_flexRow__i77lL"};